jQuery(document).ready(function($) {

    var $stickyCta = $('.sticky-cta');
    var $stickyCtaModule = $('.sticky-cta').closest('.sticky-cta-module');

    function syncTermsState($toggle) {
        $toggle.closest('.sticky-cta').toggleClass('sticky-cta--terms-opened', $toggle.is(':checked'));
    }

    function updateBottomOffset() {
        var bar = document.getElementById('cookie-law-info-bar');
        var isVisible = bar && window.getComputedStyle(bar).display !== 'none' && window.getComputedStyle(bar).visibility !== 'hidden';
        var offset = isVisible ? Math.ceil(bar.getBoundingClientRect().height) + 'px' : '0px';
        document.documentElement.style.setProperty('--sticky-cta-bottom-offset', offset);
    }

    function bindCookieBarObserver(bar) {
        if (!bar || bar.dataset.stickyCtaObserved) {
            return false;
        }
        bar.dataset.stickyCtaObserved = '1';
        if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(updateBottomOffset).observe(bar);
        }
        return true;
    }

    function updateStickyCtaVisibility() {
        if (!$stickyCtaModule.length) {
            $stickyCta.removeClass('sticky-cta--visibility-pending');
            return;
        }
        $stickyCtaModule.addClass('sticky-cta-module--ready');
        var trigger = document.querySelector('.one-liner-info-bonuser');
        if (!trigger) {
            $stickyCtaModule.removeClass('sticky-cta-module--hidden');
            $stickyCta.removeClass('sticky-cta--visibility-pending');
            return;
        }
        var triggerBottom = trigger.getBoundingClientRect().bottom + window.scrollY;
        var isPastTrigger = window.scrollY > triggerBottom;
        $stickyCtaModule.toggleClass('sticky-cta-module--hidden', !isPastTrigger);
        $stickyCta.removeClass('sticky-cta--visibility-pending');
    }

    var visibilityTicking = false;
    function requestVisibilityUpdate() {
        if (visibilityTicking) {
            return;
        }
        visibilityTicking = true;
        window.requestAnimationFrame(function() {
            updateStickyCtaVisibility();
            visibilityTicking = false;
        });
    }

    $(document).on('click', '.remove-cta', function() {
        $(this).closest('.sticky-cta').remove();
    });

    $(document).on('change', '.sticky-cta-terms-collapsible .toggle', function() {
        syncTermsState($(this));
    });

    $('.sticky-cta-terms-collapsible .toggle').each(function() {
        syncTermsState($(this));
    });

    $(window).on('resize.stickyCtaCookie', function() {
        updateBottomOffset();
        requestVisibilityUpdate();
    });
    $(window).on('scroll.stickyCtaVisibility', requestVisibilityUpdate);
    updateBottomOffset();
    updateStickyCtaVisibility();

    if (!bindCookieBarObserver(document.getElementById('cookie-law-info-bar')) && typeof MutationObserver !== 'undefined') {
        var mo = new MutationObserver(function() {
            var bar = document.getElementById('cookie-law-info-bar');
            if (bindCookieBarObserver(bar)) {
                updateBottomOffset();
                mo.disconnect();
            }
        });
        mo.observe(document.body, { childList: true, subtree: true });
    }

});